import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Table from '../../atoms/table/Table';
import NoDataTableRow from '../../molecules/table/NoDataTableRow';
import FileTableRow from '../../molecules/table/FileTableRow';
import FileTableHeader from '../../molecules/table/FileTableHeader';
const FileTable = ({ files }) => {
    const getDataRows = () => {
        if (files.length === 0) {
            return _jsx(NoDataTableRow, {});
        }
        return (files.length > 0 &&
            files.map(reportExport => (_jsx(FileTableRow, { file: reportExport }, reportExport.id))));
    };
    return (_jsxs(Table, { children: [_jsx(FileTableHeader, {}), getDataRows()] }));
};
export default FileTable;
